@use '../../style/theme';
@use '../../style/rest';

:host {
  @include rest.rest;
  display: block;
}

.modal-row {
  opacity: 0;
  pointer-events: none;
  will-change: transform;
}

.modal-row.open {
  opacity: 1;
  pointer-events: auto;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 1ch;
  background: rgba(0, 0, 0, 0.3);
}

.modal-row {
  .modal-child {
    transform: translateY(100%);
    transition: transform 420ms ease;
    position: relative;

    .modal-loading {
      display: none;
      position: absolute;
      top: 160px;
      left: 50%;
      transform: translateX(-50%);
      width: 24px;
      height: 24px;
    }
    &.loading .modal-loading {
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        width: 24px;
        height: 24px;
      }
    }

    &.loading .modal-content {
      visibility: hidden;
    }
  }

  &.open .modal-child {
    transform: translateY(0%);
  }
}

.modal-child {
  padding: 16px 8px 24px;
  background-color: #fff;
  width: 100%;
}

.modal-close-button-wrap {
  padding-left: 8px;
  .modal-close-button {
    width: 32px;
    display: block;
    fill: var(--color-label);
    cursor: pointer;
  }
}
